import React, { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import PortalChrome from '../../components/portal/PortalChrome';
import { CloseX, ignoreBackdropEscapeClose } from '../../components/portal/portalUi';
import { PortalProfileProvider, usePortalProfile } from '../../contexts/PortalProfileContext';
import { PortalPoshakaProvider } from '../../contexts/PortalPoshakaContext';
import { useAuth } from '../../contexts/AuthContext';

function PortalLoadingGate({ children }) {
  const { detailsLoading } = usePortalProfile();
  return (
    <>
      <Dialog
        open={detailsLoading}
        onClose={(e, reason) => {
          if (ignoreBackdropEscapeClose(e, reason)) return;
        }}
        disableEscapeKeyDown
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'flex-end', pr: 1 }}>
          <CloseX onClick={() => {}} disabled title="Please wait" />
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 2 }}>
            <CircularProgress size={28} />
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Loading your account…</Typography>
              <Typography variant="body2" color="text.secondary">Please wait while we retrieve your information</Typography>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      {children}
    </>
  );
}

export default function PortalLayout() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { staff } = useAuth();

  useEffect(() => {
    if (!staff?.subject || !id) return;
    if (String(id) !== String(staff.subject)) {
      navigate(`/devotees/${staff.subject}/home`, { replace: true });
    }
  }, [staff?.subject, id, navigate]);

  return (
    <PortalProfileProvider>
      <PortalPoshakaProvider>
        <PortalLoadingGate>
          <PortalChrome>
            <Outlet />
          </PortalChrome>
        </PortalLoadingGate>
      </PortalPoshakaProvider>
    </PortalProfileProvider>
  );
}
